import React from "react";
import three_slider_1 from '../../assets/three_slider_1.avif';
import three_slider_2 from '../../assets/three_slider_2.avif';
import three_slider_3 from '../../assets/three_slider_3.avif';
import three_slider_4 from '../../assets/three_slider_4.avif';
import three_slider_5 from '../../assets/three_slider_5.avif';
import three_slider_6 from '../../assets/three_slider_6.avif';

const cards = [
  {
    img: three_slider_1,
    title: 'Стратегия и брендинг',
    text: 'Разрабатываем стратегии и строим сильные бренды.',
    bg: 'bg-danger-bg',
  },
  {
    img: three_slider_2,
    title: 'Digital-реклама',
    text: 'Таргетинг, контекстная и медийная реклама.',
    bg: 'bg-[#E0F7FF]',
  },
  {
    img: three_slider_3,
    title: 'Создание контента',
    text: 'Фото, видео, тексты и визуалы для платформ.',
    bg: 'bg-[#F0EFFF]',
  },
  {
    img: three_slider_4,
    title: 'SMM и сообщества',
    text: 'Ведем соцсети и создаем лояльное сообщество.',
    bg: 'bg-warning-bg',
  },
  {
    img: three_slider_5,
    title: 'Веб-разработка',
    text: 'Создаем сайты и магазины, которые конвертируют.',
    bg: 'bg-[#E8FFF0]',
  },
  {
    img: three_slider_6,
    title: 'Аналитика',
    text: 'Измеряем результат и улучшаем показатели.',
    bg: 'bg-[#FFE0FB]',
  },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const CategoryShowcase = () => {
  return (
    <section className="bg-bg py-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока (в стиле минимализма из слайдера) */}
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Направления
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Наши услуги
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Получить консультацию <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Сетка: 6 колонок в один ряд на больших экранах */}
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-line-strong bg-surface transition-all hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]"
            >
              {/* Верхняя часть: Пастельный фон + большая картинка (w-[75%]) */}
              <div className={`relative flex aspect-[4/3] w-full items-center justify-center overflow-hidden transition-colors duration-500 ${card.bg}`}>
                <img 
                  src={card.img} 
                  alt={card.title} 
                  className="h-auto w-[75%] object-contain transition duration-500 ease-out group-hover:scale-110" 
                />
              </div>

              {/* Нижняя часть: Текст */}
              <div className="flex flex-col p-4">
                <h3 className="text-[13px] font-medium leading-tight text-content transition-colors group-hover:text-accent-hover">
                  {card.title}
                </h3>
                
                {/* Описание идет сразу за заголовком */}
                <p className="mt-1.5 text-[11px] font-light leading-relaxed text-muted">
                  {card.text}
                </p>
                
                {/* Ссылка "Подробнее" больше не растягивает блок, а аккуратно стоит внизу текста */}
                <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-medium text-accent transition-transform duration-300 group-hover:translate-x-1">
                  <span>Подробнее</span>
                  <Icon name="arrow" size={12} />
                </div>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CategoryShowcase;